import React, { useState, useEffect } from 'react';
import './SideMenu.css';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, IconButton, Tooltip, Collapse } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from '../../assets/logo.png';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RateReviewIcon from '@mui/icons-material/RateReview';
import ArticleIcon from '@mui/icons-material/Article';

const SideMenuADM = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [nomeUsuario, setNomeUsuario] = useState('');
  useEffect(() => {
    // Usuário
    let nomeUsuario = '';
    const user = localStorage.getItem('user');
    if (user) {
      try {
        nomeUsuario = JSON.parse(user).USU_NOME || '';
      } catch {
        nomeUsuario = user;
      }
    }
    setNomeUsuario(nomeUsuario);
  
  }, []);
  
  const [openSubmenu, setOpenSubmenu] = useState({
    cadastro: false,
    relatorios: false,
    gerenciar: false
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('menuStateChange', {
      detail: { isCollapsed: isCollapsed }
    }));
  }, [isCollapsed]);

  const handleLogout = () => {
    localStorage.removeItem('tipoUsuario');
    localStorage.removeItem('idUsuario');
    localStorage.removeItem('idPrefeitura');
    localStorage.removeItem('nomePrefeitura');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    navigate('/');
    if (onClose) onClose();
  };

  const toggleCollapse = () => {
    if (isMobile) {
      if (onClose) onClose();
    } else {
      setIsCollapsed((prev) => !prev);
    }
  };

  const handleSubmenuClick = (menu) => {
    setOpenSubmenu(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  const menuItems = [
    { 
      text: 'Home', 
      icon: <HomeIcon />, 
      path: '/adm/dashboard',
      subItems: []
    },

    {
      text: 'Revisar Compras',
      icon:  <RateReviewIcon />,
      path: '/adm/RevisarCotacao'
    },
    { 
      text: 'Cadastro', 
      icon: <AssignmentIndIcon />, 
      path: '/adm/cadastro',
      subItems: [
        { text: 'Usuários', path: '/adm/cadastro/usuario' },
        { text: 'Prefeitura', path: '/adm/cadastro/prefeitura' },
        { text: 'Fornecedor', path: '/adm/cadastro/fornecedor' },
        { text: 'Veículo', path: '/adm/cadastro/veiculo' },
        { text: 'Contrato', path: '/adm/cadastro/contrato' },
        { text: 'Secretaria', path: '/adm/cadastro/secretaria' },
      ]
    },
    {
      text: 'Gerenciar',
      icon: <ManageAccountsIcon />,
      path: '/adm/gerenciar',
      subItems: [
        { text: 'Prefeituras', path: '/adm/gerenciar/prefeitura' },
        { text: 'Fornecedores', path: '/adm/gerenciar/fornecedor' },
        { text: 'Usuários', path: '/adm/gerenciar/usuario'}
      ]
    },
    {
      text: 'Historico Compras',
      icon:  <ArticleIcon />,
      path: '/adm/HistoricoCompraADM'
    },
    { 
      text: 'Relatórios', 
      icon: <AssessmentIcon />, 
      path: '/adm/Relatorio',
      subItems: [
        { text: 'Relatório Geral', path: '/adm/Relatorio/relatorioGeral' },
        { text: 'Relatório Fornecedor', path: '/adm/Relatorio/relatorioFornecedor' },
      ]
    },

  ];

  const shouldCollapse = !isMobile && isCollapsed;

  const handleNavigation = (path) => {
    if (shouldCollapse) {
      setIsCollapsed(false); // Expande o menu
    } else {
      navigate(path);
      if (isMobile && onClose) {
        onClose();
      } else {
        setIsCollapsed(true);
      }
    }
  };
  
  const handleMenuClick = (item) => {
    if (item.subItems && item.subItems.length > 0) {
      // Se o menu está colapsado, expande primeiro
      if (shouldCollapse) {
        setIsCollapsed(false);
        return;
      }
      // Se já está expandido, abre/fecha o submenu
      handleSubmenuClick(item.text.toLowerCase());
    } else {
      handleNavigation(item.path);
    }
  };

  const handleSubItemClick = (path) => {
    handleNavigation(path);
  };

  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      className={`side-menu ${shouldCollapse ? 'collapsed' : ''} ${isOpen ? 'open' : ''}`}
      variant={isMobile ? "temporary" : "permanent"}
      PaperProps={{
        sx: {
          width: shouldCollapse ? '64px' : '280px',
          transition: 'width 0.3s ease, transform 0.3s ease',
          overflowX: 'hidden'
        }
      }}
    >
      <div className="menu-header">
        <div className="header-content">
          {!shouldCollapse && (
            <div className="user-info">
              <AccountCircleIcon className="user-icon" />
              <div className="user-details">
              <h3>{nomeUsuario || 'Usuário'}</h3>
                <span>Administrador</span>
              </div>
            </div>
          )}
          <IconButton
            onClick={toggleCollapse}
            className="menu-button"
            sx={{
              color: 'white',
              padding: '4px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            {isMobile ? <ChevronLeftIcon /> : (shouldCollapse ? <MenuIcon /> : <ChevronLeftIcon />)}
          </IconButton>
        </div>
      </div>
      <Divider />
      <List className="menu-list">
        {menuItems.map((item) => (
          <React.Fragment key={item.text}>
            <Tooltip title={shouldCollapse ? item.text : ""} placement="right">
              <ListItem
                button
                onClick={() => handleMenuClick(item)}
                className="menu-item"
                sx={{
                  justifyContent: shouldCollapse ? 'center' : 'flex-start',
                  padding: shouldCollapse ? '12px 0' : '12px 16px'
                }}
              >
                <ListItemIcon className="menu-icon" sx={{ minWidth: shouldCollapse ? 0 : 40 }}>
                  {item.icon}
                </ListItemIcon>
                {!shouldCollapse && (
                  <>
                    <ListItemText primary={item.text} />
                    {item.subItems && item.subItems.length > 0 && (
                      openSubmenu[item.text.toLowerCase()] ? <ExpandLess /> : <ExpandMore />
                    )}
                  </>
                )}
              </ListItem>
            </Tooltip>
            {!shouldCollapse && item.subItems && item.subItems.length > 0 && (
              <Collapse in={openSubmenu[item.text.toLowerCase()]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {item.subItems.map((subItem) => (
                    <ListItem
                      button
                      key={subItem.text}
                      onClick={() => handleSubItemClick(subItem.path)}
                      sx={{ pl: 4 }}
                    >
                      <ListItemText primary={subItem.text} />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        ))}
      </List>
      <Divider />
      <div className="menu-footer">
        <Tooltip title={shouldCollapse ? "Sair" : ""} placement="right">
          <ListItem
            button
            onClick={handleLogout}
            className="logout-item"
            sx={{
              justifyContent: shouldCollapse ? 'center' : 'flex-start',
              padding: shouldCollapse ? '12px 0' : '12px 16px'
            }}
          >
            <ListItemIcon sx={{ minWidth: shouldCollapse ? 0 : 40 }}>
              <LogoutIcon />
            </ListItemIcon>
            {!shouldCollapse && <ListItemText primary="Sair" />}
          </ListItem>
        </Tooltip>
        <Divider />
        {!shouldCollapse && (
          <div className="footer-content">
            <img src={Logo} alt="Logo G2" className="footer-logo" />
            <p className="footer-text">Desenvolvido por G2</p>
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default SideMenuADM; 